export const Roles = {
  ADMIN: 'Admin',
  MANAGER: 'AletheiaManager',
  TRAINER: 'Trainer',
}
